import * as angular from "angular";
import {IController} from "angular";
import {RuleActionData} from "../../models/rule-action-data";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {RuleFilterDataType} from "../../types/rule-filter-data.type";

export class ActionObjectListDataTableComponent implements IController {

  actionDataList: RuleActionData;
  actionData: RuleActionData;
  bringozSelectParams: any;
  onAddObjectListValue: Function;
  onRemoveObjectListValue: Function;

  private siteInfo: any;
  private ruleActionDataMap: {};
  public ruleFilterDataType: typeof RuleFilterDataType = RuleFilterDataType;
  public actionDataListFieldNames: string[];

  constructor(private siteContextService: SiteContextService) {
    this.siteInfo = this.siteContextService.getSiteInfo();
  }

  $onInit() {
    if (!!this.actionData) {
      this._initActionDataInputsMap();
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.actionData && !changes.actionData.isFirstChange()) {
      if (!!this.actionData) {
        this._initActionDataInputsMap();
      }
    }
  }

  onChange(value: any, valueItem: {}, key: string) {
    valueItem[key] = value;
  }

  onChipsChange(items: string[], valueItem: {}, key: string): void {
    valueItem[key] = items;
  }

  private _initActionDataInputsMap() {
    this.actionDataListFieldNames = this.actionData.dataList.map(d => d.fieldName);
    this.ruleActionDataMap = {};
    this.actionData.dataList.forEach((i: RuleActionData) => {
      const ruleActionData: RuleActionData = new RuleActionData(i);
      if (ruleActionData.entity === 'ProviderType') {
        ruleActionData.values = this.siteInfo.supportedThreePlProviders;
      }
      this.ruleActionDataMap[ruleActionData.fieldName] = ruleActionData;
    })
  }

}

angular
  .module('bringoz.admin.ruleEngine')
  .component('actionObjectListDataTable', {
    bindings: {
      actionData: '<',
      actionDataList: '<',
      bringozSelectParams: '<',
      onAddObjectListValue: '&',
      onRemoveObjectListValue: '&'
    },
    template: require('./action-object-list-data-table.html').default,
    controller: ActionObjectListDataTableComponent
  });
